import { GuideLinkButton, PageHeaderActionsPortal } from '@mews-commander/ui';
import { ArticlePath, createGuideLink } from '@mews-commander/enums';
import { ClearAction } from './ClearAction';
import { ScannerAction } from './ScannerAction';
import { PrinterAction } from './PrinterAction';

export const ProfileTabActions = ({ customerId }: { customerId: string }) => (
    <PageHeaderActionsPortal>
        <ClearAction customerId={customerId} />
        <ScannerAction />
        <PrinterAction />
        <GuideLinkButton guideLink={createGuideLink(ArticlePath.UpdateDeleteCustomerProfile)} />
    </PageHeaderActionsPortal>
);
